import { createRequestHeaders } from '@zg-rentals/particles-js-requester';
import { getClient as getRentalGrowthClient, setClient } from '@zg-rentals/ts-rental-growth-api-client';
import { getClient } from '@zg-rentals/ts-client-http-client';

type GrowthRequestContext = {
  app: { originalServerSideRequestCookies?: Record<string, string>; userAgent?: string };
  user: { ip?: string };
};

// Use the base http client (always initialized) and extend with the growth prefixUrl,
// mirroring the original rental-growth-web setClient pattern.
export const setupGrowthClient = (prefixUrl: string) => {
  if (!getRentalGrowthClient()) {
    setClient(getClient().extend({ prefixUrl }));
  }
};

export const growthClientWithRequestContext = (state: GrowthRequestContext) =>
  getRentalGrowthClient()?.extend({
    headers: createRequestHeaders({
      cookies: state.app.originalServerSideRequestCookies,
      ip: state.user.ip,
      userAgent: state.app.userAgent,
      brand: 'zillow',
    }),
  });
